module.exports = __webpack_public_path__ + "img/university_4.423a2740.jpg";